import axios from '../config/axios'

class ApiService {
  private static baseUrl = process.env.REACT_APP_GATEWAY_BASE_URL

  static async get(url: string, params?: any, config?: any) {
    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🔄 [APISERVICE] GET - URL absoluta detectada:', {
        urlOriginal: url,
        baseUrl: baseUrl,
        urlFinal: finalUrl,
        isDuplicated: url.startsWith(baseUrl),
        params,
      });
      const response = await axios.get(finalUrl, { params, ...config })
      return response
    }

    console.log('🔄 [APISERVICE] GET - URL relativa:', {
      url: url,
      willBeConcatenatedWith: this.baseUrl,
      params,
    });
    const response = await axios.get(url, { params, ...config })
    return response
  }

  static async post(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] POST chamado:', {
      url,
      hasData: !!data,
      dataType: data?.constructor?.name || typeof data,
      isFormData: data instanceof FormData,
      formDataKeys: data instanceof FormData ? Array.from(data.keys()) : undefined,
      configKeys: config ? Object.keys(config) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] URL final:', finalUrl);
      const response = await axios.post(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta POST recebida:', {
        status: response.status,
        statusText: response.statusText,
        hasData: !!response.data,
        dataType: typeof response.data
      });
      return response
    }

    console.log('🎯 [APISERVICE] URL final:', url);
    const response = await axios.post(url, data, config)

    console.log('✅ [APISERVICE] Resposta POST recebida:', {
      status: response.status,
      statusText: response.statusText,
      hasData: !!response.data,
      dataType: typeof response.data
    });

    return response
  }

  static async put(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] PUT chamado:', {
      url,
      hasData: !!data,
      dataType: data?.constructor?.name || typeof data,
      isFormData: data instanceof FormData,
      formDataKeys: data instanceof FormData ? Array.from(data.keys()) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] URL final:', finalUrl);
      const response = await axios.put(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta PUT recebida:', {
        status: response.status,
        statusText: response.statusText,
        hasData: !!response.data
      });
      return response
    }

    console.log('🎯 [APISERVICE] URL final:', url);
    const response = await axios.put(url, data, config)

    console.log('✅ [APISERVICE] Resposta PUT recebida:', {
      status: response.status,
      statusText: response.statusText,
      hasData: !!response.data
    });

    return response
  }

  static async delete(url: string, config?: any) {
    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      const response = await axios.delete(finalUrl, config)
      return response
    }

    const response = await axios.delete(url, config)
    return response
  }

  static async patch(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] PATCH chamado:', {
      url,
      hasData: !!data,
      dataKeys: data ? Object.keys(data) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] PATCH - URL final:', finalUrl);
      const response = await axios.patch(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta PATCH recebida:', {
        status: response.status,
        statusText: response.statusText
      });
      return response
    }

    console.log('🎯 [APISERVICE] PATCH - URL final:', url);
    const response = await axios.patch(url, data, config)
    console.log('✅ [APISERVICE] Resposta PATCH recebida:', {
      status: response.status,
      statusText: response.statusText
    });
    return response
  }

  static stock = {
    findAll: (params?: any) => this.get('/backend/stock/findAll', params),
    findById: (id: number) => this.get(`/backend/stock/${id}`),
    create: (data: any) => this.post('/backend/stock', data),
    update: (id: number, data: any) => this.put(`/backend/stock/${id}`, data),
    delete: (id: number) => this.delete(`/backend/stock/${id}`),
    updateCode: (id: number, data: any) => this.patch(`/backend/stock/${id}/code`, data),
    getTotalStock: () => this.get('/backend/stock/getTotalStock')
  }

  static auth = {
    login: (credentials: any) => this.post('/backend/login', credentials),
    googleAuth: (token: any) => this.post('/backend/googleAuthenticate', token),
    magicLogin: (hash: string) => this.get('/backend/magic-login', { h: hash }),
    register: (userData: any) => this.post('/backend/user', userData),
    resetPassword: (email: string) => this.post('/backend/reset-password', { email }),
    resetPasswordConfirm: (data: any) => this.post('/backend/reset-password/reset', data)
  }

  static certificates = {
    findById: (id: number) => this.get(`/certificates/certificate/${id}`),
    getUtils: (id: number) => this.get(`/certificates/certificate/utils/view/${id}`),
    getTypes: () => this.get('/certificates/certificate/utils/types'),
    getMaterials: (params?: any) => this.get('/certificates/certificate/utils/materials', params),
    getHeatNumbers: (params?: any) => this.get('/certificates/certificate/utils/heat-numbers', params),
    getParams: (params?: any) => this.get('/certificates/param', params)
  }

  static companies = {
    findAll: (params?: any) => this.get('/companies/companies', params),
    findById: (id: number) => this.get(`/companies/companies/${id}`),
    create: (data: any) => this.post('/companies/companies', data),
    update: (id: number, data: any) => this.put(`/companies/companies/${id}`, data),
    delete: (id: number) => this.delete(`/companies/companies/${id}`),
    getTypes: () => this.get('/companies/companies/types'),
    getCepInfo: (cep: string) => this.post('/companies/address/cep', { cep })
  }

  static productionFlow = {
    getFunctions: () => this.get('/production-flow/functions'),
    createFunction: (data: any) => this.post('/production-flow/functions', data),
    getMachines: (params?: any) => this.get('/production-flow/pcp/machines', params),
    createMachine: (data: any) => this.post('/production-flow/machine', data),
    updateMachine: (id: number, data: any) => this.patch(`/production-flow/machine/${id}`, data),
    updateService: (id: number, data: any) => this.patch(`/production-flow/pcp/service/${id}`, data)
  }

  static profiles = {
    findAll: (params?: any) => this.get('/backend/profile/findAll', params),
    findById: (id: number) => this.get(`/backend/profile/find/${id}`),
    create: (data: any) => this.post('/backend/profile', data),
    delete: (id: number) => this.delete(`/backend/profile/${id}`),
    getTotal: (params?: any) => this.get('/backend/profile/count', params)
  }

  static user = {
    findById: (id: number) => this.get(`/backend/user/${id}`),
    me: () => this.get('/backend/user/me'),
    generateLink: (data: any) => this.post('/backend/user/link-generator', data)
  }

  static movements = {
    find: (params?: any) => this.get('/backend/stock-movement/find', params),
    getTotal: (params?: any) => this.get('/backend/stock-movement/count', params)
  }

  static steelOrders = {
    createTenant: (data: any) => this.post('/backend/tenant', data)
  }

  static ocr = {
    process: (data: any) => this.post('https://ordeno-ocr-260311756054.southamerica-east1.run.app/ocr', data)
  }

  static addStockModal = {
    uploadExcel: (data: any, headers: any) => this.post('/backend/import-from-excel/upload', data, { headers }),
    createStock: (endpoint: string, data: any) => this.post(endpoint, data),
    getStockData: (endpoint: string) => this.get(endpoint)
  }

  static reverseMovement = {
    reverse: (ploomesId: number, data: any) => this.patch(`/backend/reverse-stock-movement/${ploomesId}`, data)
  }

  static admin = {
    inviteNewAdmin: (email: string) => this.post('/backend/new-admin/email', { email })
  }

  static resources = {
    findById: (id: number) => this.get(`/resources/resource/${id}`),
    create: (data: any) => this.post('/resources/resource', data),
    update: (id: number, data: any) => this.patch(`/resources/resource/${id}`, data),
    delete: (id: number) => this.delete(`/resources/resource/${id}`),
    getCategories: (params?: any) => this.get('/resources/resource/util/categories', params),
    createCategory: (data: any) => this.post('/resources/resource/util/categories', data),
    deleteCategory: (id: number) => this.delete(`/resources/resource/util/categories/${id}`),
    getTypes: (params?: any) => this.get('/resources/resource/util/types', params),
    createType: (data: any) => this.post('/resources/resource/util/types', data),
    deleteType: (id: number) => this.delete(`/resources/resource/util/types/${id}`)
  }

  static services = {
    getMachines: (params?: any) => this.get('/services/service-stage/util/machine', params),
    getServices: (params?: any) => this.get('/production-flow/pcp/services', params),
    updateService: (id: number, data: any) => this.patch(`/production-flow/service/${id}`, data),
    findById: (id: number) => this.get(`/services/service-stage/${id}`),
    create: (data: any) => this.post('/services/service-stage', data),
    update: (id: number, data: any) => this.patch(`/services/service-stage/${id}`, data),
    getCategories: (params?: any) => this.get('/services/service-stage/util/categories', params),
    createCategory: (data: any) => this.post('/services/service-stage/util/categories', data),
    deleteCategory: (id: number) => this.delete(`/services/service-stage/util/categories/${id}`),
    getTypes: (params?: any) => this.get('/services/service-stage/util/types', params),
    createType: (data: any) => this.post('/services/service-stage/util/types', data),
    deleteType: (id: number) => this.delete(`/services/service-stage/util/types/${id}`),
    createMachine: (data: any) => this.post('/services/service-stage/util/machine', data),
    deleteMachine: (id: number) => this.delete(`/services/service-stage/util/machine/${id}`)
  }

  static pcp = {
    findById: (id: number) => this.get(`/production-flow/pcp/${id}`),
    addService: (data: any) => this.post('/production-flow/pcp/service', data),
    confirm: (id: number, data: any) => this.patch(`/production-flow/pcp/${id}/status`, data),
    generatePDF: (id: number, params?: any) => this.get(`/production-flow/pcp/${id}/export`, params),
    getHistory: (id: number) => this.get(`/production-flow/pcp/${id}/history`),
    selectMaterials: (data: any) => this.post('/production-flow/pcp/select-materials', data),
    selectServices: (data: any) => this.post('/production-flow/pcp/select-services', data),
    split: (id: number, data: any) => this.post(`/production-flow/pcp/${id}/split`, data)
  }

  static structure = {
    getColumns: (id: number) => this.get(`/certificates/column/${id}`)
  }

  static status = {
    getCurrentStatus: (params?: any) => this.get('/backend/stock/current-status', params)
  }

  static parameters = {
    getFormats: (params?: any) => this.get('/certificates/param/formats', params)
  }

  static infiniteSelect = {
    get: (url: string, config: any) => this.get(url, config?.params, config),
    post: (url: string, payload: any, config: any) => this.post(url, payload, config),
    delete: (url: string, config: any) => this.delete(url, config)
  }
}

export default ApiService
